import { useEffect, useState, Dispatch, SetStateAction } from "react";
import { PlusCircle } from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import FormButton from "../../../Components/Buttons/FormButton";
import FormModal from "../../../Components/FormTag/FormModal";
import FormToggle from "../../../Components/FormTag/FormToggle";
import FormSelect from "../../../Components/FormTag/FormSelect";
import InputFiled from "../../../Components/FormTag/InputFiled";
import {
  customerDefaultvalues,
  CustomerProps,
  CustomerShipToProps,
} from "../model/customer.model";
import { ApiResponse, SelcetOption } from "../../../model/common/apiResponse";
import {
  getcustomerShiptoById,
  submitCustomerShipTo,
  updateCustomerShipTo,
} from "../service/customer.service";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Components/GlobalLoader/Loader";
import useClientStore, { Client } from "../../../store/client/useClientStore";
import { formatPhoneNumber } from '../../../Utility/Utility';
import { CONTACT_PHONE_PATTERN_ERR_MSG } from '../../../Shared/Helper/ValidationMessage';
import { CONTACT_NUM } from '../../../Shared/Helper/Constant';

interface ShipToProps {
  customerDetails?: CustomerProps;
  countryList?: SelcetOption[];
  client?: any;
  shiptoCodeId?: string | null;
  counter?: number;
  onUpdateShiptoData: (data: any) => void;
  setShiptoCodeId?: React.Dispatch<React.SetStateAction<string>> | null;
}
export default function ShipToCodeAddEdit(props: ShipToProps) {
  const {
    customerDetails,
    countryList,
    shiptoCodeId,
    setShiptoCodeId,
    counter,
    onUpdateShiptoData,
  } = props;
  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
    setValue,
    trigger,
  } = useForm<CustomerShipToProps>({
    defaultValues: customerDefaultvalues,
  });
  const [modalShow, setModalShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shiptoDetailsData, setShiptoDetailsData] =
    useState<CustomerShipToProps>();
  const { getSelectedClient } = useClientStore();
  const [clientData, setClientData] = useState<Client | null>(null);
  useEffect(() => {
    const subscription = getSelectedClient().subscribe((client) => {
      setClientData(client);
    });

    return () => subscription.unsubscribe();
  }, [getSelectedClient]);
  useEffect(() => {
    if (!counter) return;
    if (shiptoCodeId) {
      setModalShow(true);
      setLoading(true);
      getcustomerShiptoById(shiptoCodeId)
        .then((response) => {
          if (response.status === 200 && response.data) {
            response.data.country = response.data.country.code;
            setShiptoDetailsData(response.data);
            reset(response.data);
          } else {
            console.error("Failed to fetch customer data:", response.data);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [shiptoCodeId, counter]);

  const handelModalButton = () => {
    if (setShiptoCodeId) {
      setShiptoCodeId("");
    }

    reset(customerDefaultvalues);
    setModalShow(!modalShow);
  };
  const getClientData = async () => {
    if (
      clientData &&
      Object.keys(clientData).length > 0 &&
      clientData.code !== "all"
    ) {
      return clientData;
    } else {
      toast.error("Client code is required!", { duration: 2000 });
      setSubmitting(false);
    }
  };
  const saveData: SubmitHandler<CustomerShipToProps> = async (
    data: CustomerShipToProps
  ) => {
    await getClientData();
    if (!clientData?.id || !clientData?.code || clientData.code === "all") {
      setSubmitting(false);
      return;
    }
    if (submitting) return;
    const formattedCustomerData = {
      ...data,
      client: {
        code: clientData?.code,
      },
      country: {
        code: data.country,
      },
      customer: {
        code: customerDetails?.code,
      },
    };
    let response: ApiResponse<any>;
    if (shiptoCodeId) {
      response = await updateCustomerShipTo(
        shiptoCodeId,
        formattedCustomerData
      );
    } else {
      response = await submitCustomerShipTo(formattedCustomerData);
    }
    if (response.status == 201 || response.status == 200) {
      const operationType = shiptoCodeId ? "updated" : "created";
      toast.success("Customer Shipto " + operationType + " successfully!", {
        duration: 2000,
      });
      handelModalButton();
      onUpdateShiptoData(response.data);
      reset(customerDefaultvalues);
    } else if (response.status == 400) {
      if (response.error.detail.code) {
        toast.error(response.error.detail.code, { duration: 2000 });
      }
      setSubmitting(false);
    } else {
      toast.error("An error occurred while submitting Customer Shipto.", {
        duration: 2000,
      });
      setSubmitting(false);
    }
  };
  const handleToggleChange = (checked: any) => {
    if (checked) {
      reset(customerDetails);
    } else {
      reset(shiptoDetailsData ?? customerDefaultvalues);
    }
  };
  const footer = (
    <>
      <div className="mb-2 bg-white rounded mt-5">
        <div className="d-flex flex-row-reverse mt-5">
          <FormButton
            className="sph-btn me-4"
            handleClick={handleSubmit(saveData)}
            tabIndex={23}
          >
            {shiptoCodeId ? "Update" : "Add"}
          </FormButton>
          <FormButton
            className="sph-btn sph-shift me-4"
            handleClick={handelModalButton}
            tabIndex={24}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
  return (
    <>
      <Toaster />
      <div>
        <div className="cursor-pointer" onClick={handelModalButton}>
          <small className="fw-bold">Add Ship to Code</small>
          <span className="cursor-pointer ms-2">
            <PlusCircle />
          </span>
        </div>
        <FormModal
          show={modalShow}
          handleClose={handelModalButton}
          modalTitle={`${shiptoCodeId ? "Edit" : "Add"} Ship To Code`}
          footer={footer}
          modalSize="xl"
          customClassName="ship-to-code-modal"
        >
          <div className="ship-to-code-modal-height">
            {!loading ? (
              <>
                <div className="my-2 bg-white rounded px-3 pb-3">
                  <div className="d-flex px-2 mt-3 gap-3">
                    <div className="col-4 px-2">
                      <label className="fw-medium">Ship To Code *</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="code"
                          required={true}
                          errors={errors.code}
                          className="form-control"
                          placeholder="Enter Code"
                          tabIndex={12}
                          autoFocus={true}
                        />
                      </div>
                    </div>
                    <div className="col-4 px-2">
                      <label className="fw-medium">Name *</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="name"
                          errors={errors.name}
                          className="form-control"
                          placeholder="Enter  Name"
                          required={true}
                          tabIndex={13}
                        />
                      </div>
                    </div>

                    <div className="col-3 d-flex px-2 justify-content-center">
                      <div className="ms-4">
                        <label className="fw-medium">
                          Same as Bill to Code
                        </label>
                      </div>
                      <div className="form-check form-switch sidebar-toggler">
                        <div className="mx-2">
                          <FormToggle
                            onChange={handleToggleChange}
                            defaultChecked={false}
                            register={register}
                            tabIndex={22}
                            name="is_same_as_bill_code"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex px-2 mt-3 gap-3">
                    <div className="col-4 px-2">
                      <label className="fw-medium">Address 1</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="address_line_1"
                          errors={errors.address_line_1}
                          className="form-control"
                          placeholder="Enter Address 1"
                          tabIndex={15}
                        />
                      </div>
                    </div>
                    <div className="col-4 px-2">
                      <label className="fw-medium">Address 2</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="address_line_2"
                          errors={errors.address_line_2}
                          className="form-control"
                          placeholder="Enter Address 2"
                          tabIndex={16}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex px-2 mt-3 gap-3">
                    <div className="col-4 px-2">
                      <label className="fw-medium">Address 3</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="address_line_3"
                          errors={errors.address_line_3}
                          className="form-control"
                          placeholder="Enter Address 3"
                          tabIndex={16}
                        />
                      </div>
                    </div>
                    <div className="col-4 px-2">
                      <label className="fw-medium">Contact Name</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="contact_name"
                          // errors={errors.contact_name}
                          className="form-control"
                          placeholder="Enter Contact Name"
                          // required={true}
                          tabIndex={13}
                        />
                      </div>
                    </div>


                  </div>

                  <div className="d-flex px-2 mt-3 gap-3">
                      <div className="col-4 px-2">
                      <label className="fw-medium">Contact Number</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="contact_phone"
                          pattern={{
                            type: CONTACT_NUM,
                            message: CONTACT_PHONE_PATTERN_ERR_MSG,
                          }}
                          errors={errors.contact_phone}
                          className="form-control"
                          placeholder="Enter Contact Number"
                          tabIndex={17}
                          onChange={async (e: any) => {
                            const formattedNumber = formatPhoneNumber(e.target.value);
                            setValue("contact_phone", formattedNumber);
                            if (typeof trigger === 'function') {
                              await trigger("contact_phone");
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-4 px-2">
                      <label className="fw-medium">Country</label>
                      <div className="mt-1">
                        <FormSelect
                          name="country"
                          control={control}
                          optionList={countryList}
                          className="form-control p-0"
                          placeholder="Select"
                          isSearchable={true}
                          tabIndex={18}
                        />
                      </div>
                    </div>

                  </div>
                  <div className="d-flex px-2 mt-3 gap-3">
                                        <div className="col-4 px-2">
                      <label className="fw-medium">State</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="state_province"
                          errors={errors.state_province}
                          className="form-control"
                          placeholder="Enter State"
                          tabIndex={19}
                        />
                      </div>
                    </div>
                    <div className="col-4 px-2">
                      <label className="fw-medium">City</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="city"
                          errors={errors.city}
                          className="form-control"
                          placeholder="Enter City"
                          tabIndex={20}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex px-2 mt-3 gap-3">
                                        <div className="col-4 px-2">
                      <label className="fw-medium">Zip/Postal Code</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={register}
                          name="postal_code"
                          maxLength={6}
                          errors={errors?.postal_code}
                          className="form-control"
                          placeholder="Enter Zip/Postal Code"
                          tabIndex={21}
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </>
            ) : (
              <Loader />
            )}
          </div>
        </FormModal>
      </div>
    </>
  );
}
